export type Work = () => void;

export enum WorkDescription {
  state = "state",
  after_rendering = "after_rendering",
}
